import { FiltrationFilter } from "./pagination";

const mapFiltrationFilter = ({ id, value }: FiltrationFilter) => id + ":" + value;
const mapFiltrationFilterArray = (filter: FiltrationFilter[]) => filter.map(mapFiltrationFilter).join(";");

export { mapFiltrationFilter, mapFiltrationFilterArray };
